import base from '../dr-base'
import drRating from './dr-rating.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-rating',
  name: 'Rating',
  group: 'Button widgets',
  icon: 'star-half-alt',
  ...base,
  properties: {
    ...base.properties,
    HideLabel: {
      name: 'vuetifyWidgets.dr-rating.hideLabel',
      type: 'boolean',
      default: false
    },
    Value: {
      name: 'vuetifyWidgets.dr-rating.value',
      type: 'string',
      component: 'dr-value-editor'
    },
    Readonly: {
      name: 'vuetifyWidgets.dr-rating.readonly',
      type: 'string'
    },
    Size: {
      name: 'vuetifyWidgets.dr-rating.size',
      type: 'string',
      default: 35,
      enum: [
        { text: 'vuetifyWidgets.dr-rating.small', value: 35 },
        { text: 'vuetifyWidgets.dr-rating.medium', value: 50 },
        { text: 'vuetifyWidgets.dr-rating.large', value: 60 }
      ]
    },
    ActionOnclick: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-rating.actionOnclick'
    }
  }
}
  
export default {
  schema,
  component: drRating
}
  
  